import angular from "angular";
import html from "./admin_action_confirm.html";
import controller from "./admin_action_confirm.controller";

export default angular
    .module("sbApp.sbAdminActionConfirmDialog", [])
    .config(registerDialog)
    .factory("$sbAdminActionConfirmDialog", registerService());

function registerDialog($mdDialogProvider) {
    $mdDialogProvider.addPreset("adminActionConfirm", {
        methods: [
            "title",
            "textContent",
            "requiresConfirmWord", // optional: shows a confirm-word input when true
            "confirmLabel", // optional: i18n key for the confirm-word input label
            "confirmWord", // optional: word user must type to confirm (default: "RESET")
        ],
        options: function adminActionConfirmDialog() {
            return {
                templateUrl: html,
                controller: controller,
                controllerAs: "dialog",
                bindToController: true,
                clickOutsideToClose: true,
                escapeToClose: true,
            };
        },
    });
}

function registerService() {
    return function sbAdminActionConfirmDialogService($mdDialog) {
        "ngInject";

        return {
            show: _show,
        };

        function _show(options) {
            return $mdDialog.show(
                $mdDialog
                    .adminActionConfirm()
                    .title(options.title)
                    .textContent(options.description)
                    .requiresConfirmWord(options.requiresConfirmWord || false)
                    .confirmLabel(options.confirmLabel)
                    .confirmWord(options.confirmWord)
            );
        }
    };
}
